import { IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import CustomItemStatus from "../../../../../../common/components/custom_item_status";

type Props = {
  onActionEdit: (idTermoEpi: number | null, openState: boolean) => void;
  onActionDelete: (E: number | null, openState: boolean) => void;
};

export const GenerateTermoEpiColumns = ({
  onActionEdit,
  onActionDelete,
}: Props): GridColDef[] => {
  const computeStatusTitle = (status: boolean) => {
    switch (status) {
      case false:
        return "Inativo";
      case true:
        return "Ativo";
      default:
        return "?";
    }
  };

  const computeStatusColor = (status: boolean) => {
    switch (status) {
      case false:
        return "#c6c6c6";
      case true:
        return "#45b6af";
      default:
        return "#0303FF";
    }
  };

  const computeStatusDescription = (status: boolean) => {
    switch (status) {
      case false:
        return "Inativo";
      case true:
        return "Ativo";
      default:
        return "?";
    }
  };

  return [
    {
      field: "ativo",
      filterable: false,
      headerName: "Status",
      minWidth: 80,
      maxWidth: 80,
      sortable: false,
      valueGetter: (_, row) => ({
        ativo: row["ativo"] as number,
      }),
      renderCell: ({ value }) => (
        <div className="w-full h-full flex justify-center items-center gap-2">
          <CustomItemStatus
            size="autowidth"
            textSize="small"
            title={computeStatusTitle(value.ativo)}
            bgColor={computeStatusColor(value.ativo)}
            description={computeStatusDescription(value.ativo)}
          />
        </div>
      ),
    },
    {
      field: "codigo",
      filterable: false,
      headerName: "Código",
      minWidth: 100,
      maxWidth: 150,
      sortable: false,
      renderCell: (params) => (
        <div
          style={{
            whiteSpace: "normal",
            wordWrap: "break-word",
            lineHeight: "1.5",
            padding: "8px 0",
          }}
        >
          {params.value}
        </div>
      ),
    },
    {
      field: "nome",
      filterable: false,
      headerName: "Nome",
      flex: 1,
      minWidth: 200,
      sortable: false,
      renderCell: (params) => (
        <div
          style={{
            whiteSpace: "normal",
            wordWrap: "break-word",
            lineHeight: "1.5",
            padding: "8px 0",
          }}
        >
          {params.value}
        </div>
      ),
    },
    {
      field: "descricao",
      filterable: false,
      headerName: "Descrição",
      flex: 1.5,
      minWidth: 250,
      sortable: false,
      renderCell: (params) => (
        <div
          style={{
            whiteSpace: "normal",
            wordWrap: "break-word",
            lineHeight: "1.5",
            padding: "8px 0",
          }}
        >
          {params.value}
        </div>
      ),
    },
    {
      field: "idTermoEPI",
      sortable: false,
      filterable: false,
      headerName: "Ações",
      minWidth: 100,
      maxWidth: 100,
      renderCell: (params) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton onClick={() => onActionEdit(params.value, true)}>
              <DynamicIcon
                nameIcon="EditRounded"
                size={25}
                className="dark:text-white text-primary-green"
              />
            </IconButton>

            <IconButton onClick={() => onActionDelete(params.value, true)}>
              <DynamicIcon
                nameIcon="DeleteForeverRounded"
                size={25}
                className="text-red-500"
              />
            </IconButton>
          </div>
        );
      },
    },
  ];
};
